__turbopack_context__.v({
  "accountPage": "page-module__faeGia__accountPage",
  "backdrop": "page-module__faeGia__backdrop",
  "contentWrapper": "page-module__faeGia__contentWrapper",
  "headButton": "page-module__faeGia__headButton",
  "header": "page-module__faeGia__header",
  "inviteClaimError": "page-module__faeGia__inviteClaimError",
  "logo": "page-module__faeGia__logo",
  "main": "page-module__faeGia__main",
  "pageWrapper": "page-module__faeGia__pageWrapper",
  "spacer": "page-module__faeGia__spacer",
});
